import { gql, useQuery } from '@apollo/client'
import { GROUP_EVENT_MESSAGING_OPTIONS_LIMIT } from 'lib/group-event-messaging/constants'
import { DateTime } from 'luxon'

const GET_GROUP_EVENT_OPTIONS_FOR_MESSAGING = gql`
  query GroupEventOptionsForMessaging(
    $limit: Int!
    $startDateTime: DateTimeRangeInput!
  ) {
    currentUser {
      groupEvents(
        orderBy: [{ field: START_DATE_TIME, direction: ASC }]
        limit: $limit
        includeCanceled: false
        startDateTime: $startDateTime
      ) {
        id
        title
        startDateTime
        registrationCount
      }
    }
  }
`

const GET_GROUP_EVENT_MESSAGING_RECIPIENTS = gql`
  query GroupEventMessagingRecipients($id: ID!) {
    groupEvents(id: $id) {
      id
      title
      startDateTime
      enrollments {
        isCanceled
        student {
          representatives {
            contact {
              externalId
            }
          }
        }
      }
      waitlist {
        entries {
          contact {
            externalId
          }
        }
      }
    }
  }
`

const GET_GROUP_EVENT_BY_ID = gql`
  query GroupEventById($id: ID) {
    groupEvents(id: $id) {
      __typename
      id
      title
      featuredImageUrl
      slug
      description
      coachFacility {
        name
      }
      sessions {
        startDateTime
        endDateTime
      }
      coach {
        name
      }
    }
  }
`

const GET_LESSON_TYPE_BY_ID = gql`
  query GetLessonTypeById($id: ID) {
    lessonTypes(id: $id) {
      id
      title
      category
      description
      durationInMinutes
      locations {
        name
      }
      facilities {
        name
      }
      coach {
        name
      }
    }
  }
`

export const buildGroupEventOptionsForMessagingVariables = () => ({
  limit: GROUP_EVENT_MESSAGING_OPTIONS_LIMIT,
  startDateTime: {
    from: DateTime.now()
      .startOf('day')
      .toISO(),
    to: null,
  },
})

export function useGroupEventOptionsForMessaging({ skip } = {}) {
  return useQuery(GET_GROUP_EVENT_OPTIONS_FOR_MESSAGING, {
    skip,
    variables: buildGroupEventOptionsForMessagingVariables(),
  })
}

export function useGroupEventMessagingRecipients({ id, skip } = {}) {
  return useQuery(GET_GROUP_EVENT_MESSAGING_RECIPIENTS, {
    variables: { id },
    skip: skip || !id,
  })
}

export function useGetGroupEvent({ id, skip }) {
  return useQuery(GET_GROUP_EVENT_BY_ID, {
    variables: { id },
    skip,
  })
}

export function useGetLessonType({ id, skip }) {
  return useQuery(GET_LESSON_TYPE_BY_ID, {
    variables: { id },
    skip,
  })
}
